import React, { memo } from "react";
import TextInput from "@components/textInput/TextInput";
import { useHistory } from "react-router-dom";
import ImageInput from "@components/imageInput/ImageInput";
import DatePicker from "@components/datePicker/DatePicker";
import RadioBottom from "@components/radioBottom/RadioBottom";
import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import dayjs from "dayjs";
import { FormikProps } from "formik";
import { editInitialValues } from "./useAddAndEditChild";

interface EditChildComponentProps {
  formikEdit: FormikProps<typeof editInitialValues>;
  fetchingAdd: string;
  fetchingUpdate: string;
}

const EditChildComponent = ({
  formikEdit,
  fetchingAdd,
  fetchingUpdate,
}: EditChildComponentProps) => {
  const history = useHistory();
  return (
    <>
      <div className="row g-0">
        <div
          className="ManageEditChild__back col-1"
          onClick={() => {
            history.goBack();
          }}
        ></div>
        <h1 className="mt-2 col-8 formElements__inputSectionHeader header--18">
          Student Details
        </h1>
      </div>

      <TextInput
        title="Last 4 characters + alphabet *"
        placeholder="Last 4 characters + alphabet"
        {...formikEdit.getFieldProps("lastCharacter")}
        touched={formikEdit.touched.lastCharacter}
        error={formikEdit.errors.lastCharacter}
      ></TextInput>

      <ImageInput
        title="Profile image (*.jpg/jpeg/png)"
        initialValue={formikEdit.values.photoUrl}
        onChangeCrop={(fileEncode) => {
          formikEdit.setFieldValue("photoUrl", fileEncode);
        }}
      ></ImageInput>

      <div className="row gx-5">
        <div className="col-sm-6">
          <TextInput
            title="First Name *"
            placeholder="Input First Name"
            {...formikEdit.getFieldProps("firstName")}
            touched={formikEdit.touched.firstName}
            error={formikEdit.errors.firstName}
          ></TextInput>
        </div>
        <div className="col-sm-6">
          <TextInput
            title="Last Name *"
            placeholder="Input Last Name"
            {...formikEdit.getFieldProps("lastName")}
            touched={formikEdit.touched.lastName}
            error={formikEdit.errors.lastName}
          ></TextInput>
        </div>
      </div>

      <div className="row g-5">
        <div className="col-sm-6">
          <DatePicker
            title="Date of Birth *"
            onChange={(date) => {
              formikEdit.setFieldValue("dob", date);
            }}
            selected={
              formikEdit.values.dob
                ? dayjs(formikEdit.values.dob).toDate()
                : null
            }
            maxDate={new Date()}
            error={formikEdit.errors.dob}
            touched={formikEdit.touched.dob}
            placeholder={"Select Date of Birth"}
            mobileScreen
          ></DatePicker>
        </div>
        <div className="col-sm-6">
          <div className="js-multiInputWrapper js-isRequired w-100 formElements__group">
            <label className="formElements__label">Gender *</label>
            <div className="row">
              <div className="col-sm-6">
                <RadioBottom
                  name="gender"
                  value="male"
                  label="Male"
                  checked={formikEdit.values.gender === "male"}
                  onChange={() => {
                    formikEdit.setFieldValue("gender", "male");
                  }}
                ></RadioBottom>
              </div>
              <div className="col-sm-6">
                <RadioBottom
                  name="gender"
                  value="female"
                  label="Female"
                  checked={formikEdit.values.gender === "female"}
                  onChange={() => {
                    formikEdit.setFieldValue("gender", "female");
                  }}
                ></RadioBottom>
              </div>
            </div>

            {formikEdit.touched.gender && formikEdit.errors.gender ? (
              <div className="formElements__errorText">
                {formikEdit.errors.gender}
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <TextInput
        title="Medical Condition"
        placeholder="Input Medical Condition for Child"
        {...formikEdit.getFieldProps("medicalCondition")}
      ></TextInput>

      <div className="row gx-5">
        <div className="col-sm-4">
          <ButtonLoader
            type="button"
            className="mt-3 w-100"
            isLoading={
              fetchingAdd === "pending" || fetchingUpdate === "pending"
            }
            onClick={() => {
              formikEdit.submitForm();
            }}
          >
            Save
          </ButtonLoader>
        </div>
      </div>
    </>
  );
};

export default memo(EditChildComponent);
